export default __webpack_public_path__ + "static/banner-f46facd2839d85d968e32d7b355d6287.png";